<template>
  <div class="flex items-center justify-center h-full w-full relative">
    <span v-if="displayValue" class="inline-flex items-center rounded-full bg-muted-foreground px-2 py-1 text-xs text-background font-medium">
      {{ displayValue }}
    </span>
    <div v-if="hasApiData" class="absolute top-0.5 right-0.5 text-primary/70 hover:text-primary text-xs pointer-events-none">
      🛈
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  params: any
}

const props = defineProps<Props>()

// Add error handling for params access
const safeParams = computed(() => props.params || {})

const displayValue = computed(() => {
  try {
    const value = safeParams.value.value
    
    // DEBUG: Log what the CodeCell renderer is receiving
    // console.log('[CodeCell DEBUG] Received params:', {
    //   value: value,
    //   valueType: typeof value,
    //   hasValue: value !== null && value !== undefined,
    //   rowIndex: safeParams.value.rowIndex,
    //   field: safeParams.value.colDef?.field
    // })
    
    if (value === null || value === undefined) {
      // console.log('[CodeCell DEBUG] Value is null/undefined, returning empty')
      return ''
    }
    
    let codeValue = ''
    if (typeof value === 'object' && value !== null && value.value !== undefined) {
      codeValue = value.value
      // console.log('[CodeCell DEBUG] Extracted from object.value:', codeValue)
    } else if (typeof value !== 'object') {
      codeValue = value
      // console.log('[CodeCell DEBUG] Using primitive value:', codeValue)
    }
    
    if (!codeValue || codeValue === 'null' || codeValue === '') {
      // console.log('[CodeCell DEBUG] Code value is empty, returning empty string')
      return ''
    }
    
    const result = String(codeValue)
    // console.log('[CodeCell DEBUG] Final display value:', result)
    return result
  } catch (error) {
    console.warn('CodeCell displayValue error:', error)
    return ''
  }
})

const hasApiData = computed(() => {
  try {
    const value = safeParams.value.value
    return typeof value === 'object' && value !== null && 
      (value.sourceName || value.groundingMetadata || value.sourceText)
  } catch (error) {
    console.warn('CodeCell hasApiData error:', error)
    return false
  }
})
</script> 